import React from "react";

import { ControlBar } from "@salestrak/ui";
import { getMapColors } from "./map-styles";

type MapControlButtonProps = {
  isDark: boolean;
  children: React.ReactNode;
};

// The map's floating control card — the shared ControlBar chrome with the
// map-specific surface color (Google tiles aren't painted by the CSS theme,
// so the background comes pre-resolved from the map style), sized for touch.
export function MapControlButton({ isDark, children }: MapControlButtonProps) {
  const { controlBg } = getMapColors(isDark);

  return (
    <ControlBar backgroundColor={controlBg} minHeight={40}>
      {children}
    </ControlBar>
  );
}
